"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GameScene = void 0;
require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.for-each.js");
var _enemySpawnerComponent = require("../components/spawners/enemy-spawner-component");
var _fighterEnemy = require("../objects/enemies/fighter-enemy");
var _scoutEnemy = require("../objects/enemies/scout-enemy");
var _player = require("../objects/player");
var CONFIG = _interopRequireWildcard(require("../config"));
var _eventBusComponent = require("../components/events/event-bus-component");
var _enemyDestroyedComponent = require("../components/spawners/enemy-destroyed-component");
var _score = require("../objects/ui/score");
var _lives = require("../objects/ui/lives");
var _audioManager = require("../objects/audio-manager");
var _EventBus = require("../EventBus");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // import { PosterItem } from "../../types";
// export class GameScene extends Phaser.Scene {
//   camera: Phaser.Cameras.Scene2D.Camera | null = null;
//   background: Phaser.GameObjects.Image | null = null;
//   gameText: Phaser.GameObjects.Text | null = null;
//   isGameRunning: boolean = false;
//   selectedCogTiltLeftBlock: PosterItem | null = null;
//   selectedCogTiltRightBlock: PosterItem | null = null;
//   get gameHeight() {
//     return this.game.config.height as number;
//   }
//   get gameWidth() {
//     return this.game.config.width as number;
//   }
// constructor(key: string) {
//   super(key);
// }
// }
/**
 * Core Phaser 3 Scene that has the actual game play of our Space Shooter Game.
 */
class GameScene extends Phaser.Scene {
  // Add background sprite properties

  constructor() {
    super("GameScene");
    _defineProperty(this, "isGameRunning", false);
    _defineProperty(this, "selectedCogTiltLeftBlock", null);
    _defineProperty(this, "selectedCogTiltRightBlock", null);
    _defineProperty(this, "selectedCogFireBlock", null);
  }

  /**
   * Creates all of the required game objects for our scene and sets up the required
   * collision checks using the built in Phaser 3 Arcade Physics.
   * @returns {void}
   */
  create() {
    // backgrounds
    this.bg1 = this.add.sprite(0, 0, 'bg1', 0).setOrigin(0, 0).setAlpha(0.7).play('bg1');
    this.bg2 = this.add.sprite(0, 0, 'bg2', 0).setOrigin(0, 0).setAlpha(0.7).play('bg2');
    this.bg3 = this.add.sprite(0, 0, 'bg3', 0).setOrigin(0, 0).setAlpha(0.7).play('bg3');
    // Remove setAngle and setScale for now, will handle with resize

    this.resizeBackgrounds();

    // Listen for resize events
    this.scale.on('resize', this.resizeBackgrounds, this);

    // common components
    const eventBusComponent = new _eventBusComponent.EventBusComponent();

    // spawn player
    const player = new _player.Player(this, eventBusComponent);

    // spawn enemies
    const scoutSpawner = new _enemySpawnerComponent.EnemySpawnerComponent(this, _scoutEnemy.ScoutEnemy, {
      interval: CONFIG.ENEMY_SCOUT_GROUP_SPAWN_INTERVAL,
      spawnAt: CONFIG.ENEMY_SCOUT_GROUP_SPAWN_START
    }, eventBusComponent);
    const fighterSpawner = new _enemySpawnerComponent.EnemySpawnerComponent(this, _fighterEnemy.FighterEnemy, {
      interval: CONFIG.ENEMY_FIGHTER_GROUP_SPAWN_INTERVAL,
      spawnAt: CONFIG.ENEMY_FIGHTER_GROUP_SPAWN_START
    }, eventBusComponent);
    new _enemyDestroyedComponent.EnemyDestroyedComponent(this, eventBusComponent);

    // collisions for player and enemy groups
    this.physics.add.overlap(player, scoutSpawner.phaserGroup, (/** @type {Player}*/playerGameObject, /** @type {ScoutEnemy}*/enemyGameObject) => {
      if (!enemyGameObject.active || !playerGameObject.active) {
        return;
      }
      playerGameObject.colliderComponent.collideWithEnemyShip();
      enemyGameObject.colliderComponent.collideWithEnemyShip();
    });
    this.physics.add.overlap(player, fighterSpawner.phaserGroup, (/** @type {Player}*/playerGameObject, /** @type {FighterEnemy}*/enemyGameObject) => {
      if (!enemyGameObject.active || !playerGameObject.active) {
        return;
      }
      playerGameObject.colliderComponent.collideWithEnemyShip();
      enemyGameObject.colliderComponent.collideWithEnemyShip();
    });
    eventBusComponent.on(_eventBusComponent.CUSTOM_EVENTS.ENEMY_INIT, gameObject => {
      // if name is an enemy from pool, add collision check for weapon group if needed
      if (gameObject.constructor.name !== 'FighterEnemy') {
        return;
      }
      this.physics.add.overlap(player, gameObject.weaponGameObjectGroup, (/** @type {Player}*/playerGameObject, /** @type {Phaser.Types.Physics.Arcade.SpriteWithDynamicBody}*/projectileGameObject) => {
        if (!playerGameObject.active) {
          return;
        }
        gameObject.weaponComponent.destroyBullet(projectileGameObject);
        playerGameObject.colliderComponent.collideWithEnemyProjectile();
      });
    });

    // collisions for player weapons and enemy groups
    this.physics.add.overlap(player.weaponGameObjectGroup, scoutSpawner.phaserGroup, (/** @type {ScoutEnemy}*/enemyGameObject, /** @type {Phaser.Types.Physics.Arcade.SpriteWithDynamicBody}*/projectileGameObject) => {
      if (!enemyGameObject.active) {
        return;
      }
      player.weaponComponent.destroyBullet(projectileGameObject);
      enemyGameObject.colliderComponent.collideWithEnemyProjectile();
    });
    this.physics.add.overlap(player.weaponGameObjectGroup, fighterSpawner.phaserGroup, (/** @type {FighterEnemy}*/enemyGameObject, /** @type {Phaser.Types.Physics.Arcade.SpriteWithDynamicBody}*/projectileGameObject) => {
      if (!enemyGameObject.active) {
        return;
      }
      player.weaponComponent.destroyBullet(projectileGameObject);
      enemyGameObject.colliderComponent.collideWithEnemyProjectile();
    });

    // ui
    new _score.Score(this, eventBusComponent);
    new _lives.Lives(this, eventBusComponent);

    // audio
    new _audioManager.AudioManager(this, eventBusComponent);

    // ready
    _EventBus.EventBus.emit('space-ready', this);
    _EventBus.EventBus.emit('current-scene-ready', this);
  }

  // Add a method to resize backgrounds responsively
  resizeBackgrounds() {
    const width = this.scale.width;
    const height = this.scale.height;
    [this.bg1, this.bg2, this.bg3].forEach(bg => {
      if (bg) {
        bg.setDisplaySize(width, height);
        bg.setPosition(0, 0);
      }
    });
  }

  // Optionally, clean up the event listener on shutdown
  shutdown() {
    this.scale.off('resize', this.resizeBackgrounds, this);
  }
}
exports.GameScene = GameScene;